/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [{
  action: 'getSystemGamePrizesByRootId',
  message: messages.SUCCESS_GET_SYSTEM_GAME_PRIZES_BY_ROOT_ID,
  method: 'GET',
  path: '/system/:systemId/game-prizes/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.GET_SYSTEM_GAME_PRIZE,
  requestSchema: requestSchemas.systemGamePrizes.getSystemGamePrizesByRootId,
  scopes: [
    scopes.DEFAULT,
    scopes.SYSTEM_GAME_PRIZES_INPUT_BY_ROOT_ID,
  ],
}];
